import '../styles/index.scss';
import '../scripts/modules/scroll';
import '../scripts/modules/shopMap';
import '../scripts/modules/AgeGate';
import '../scripts/modules/CookiesPopup';

console.log('webpack starterkit');

